module.exports = __webpack_public_path__ + "static/img/css.b5b72fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/css.png
// module id = DVUO
// module chunks = 53